import { mutationUpdate, type UpdateHookResponse } from '../hooks'
import { useTantalimMutation } from '../mutation'
import { type UserPasswordResetInput, type UserPasswordResetSuccess, toResponseError } from '@terros/common'

export function useResetPassword(): UpdateHookResponse<UserPasswordResetInput, UserPasswordResetSuccess> {
  const mutation = useTantalimMutation<UserPasswordResetInput, UserPasswordResetSuccess>({
    url: '/user/password/reset',
  })

  async function update(input: UserPasswordResetInput): Promise<UserPasswordResetSuccess> {
    try {
      return await mutation.mutateAsync(input)
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationUpdate(mutation, update)
}
